import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OptionsProvider, useOptionsContext } from "~/Contexts/OptionsContext";
import { react2Angular } from "~/Core/React2Angular";
import { initializeTelemetry } from "~/Services/Telemetry";
import { isAuthenticated } from "~/Services/Authentication";
import { initializeUserflow } from "~/Services/Userflow";
import { useCurrentUserContext } from "~/Contexts/CurrentUserContext";

const queryClient = new QueryClient();

// right now we have to wrap this in an isAuthenticated
export const Bootstrapper = () => {
    if (!isAuthenticated()) {
        return null;
    }

    let options = useOptionsContext();
    let currentUser = useCurrentUserContext();
    initializeTelemetry(options);
    initializeUserflow(options, currentUser);

    return null;
};

angular.module("insite-admin").component("bootstrapper", react2Angular(Bootstrapper));
